'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const Guid=require('pulsar-utils/dist-es6/domain/guid');

function _areEqualDates(date1,date2){
return _.exists(date1)&&_.exists(date2)&&date1.getTime()===date2.getTime();
}let

DateTimeDirectiveController=class DateTimeDirectiveController{
static get $inject(){
return[];
}

constructor(){
this._dateId=Guid.create().toString();
this._timeId=Guid.create().toString();
}

get dateId(){
return this._dateId;
}

get timeId(){
return this._timeId;
}

get value(){
return this._value;
}

set value(newValue){
if(_.exists(newValue)){
this.date=new Date(newValue.getFullYear(),newValue.getMonth(),newValue.getDate());
this.time=new Date(newValue);
}else{
this.date=null;
this.time=null;
}
this.updateValue();
}

updateValue(){
if(!_.exists(this._date)||!_.exists(this._time)){
this._value=null;
return;
}

let newValue=new Date(
this._date.getFullYear(),
this._date.getMonth(),
this._date.getDate(),
this._time.getHours(),
this._time.getMinutes(),
this._time.getSeconds());

if(!_areEqualDates(newValue,this._value)){
this._value=newValue;
}
}

get date(){
return this._date;
}

set date(newDate){
if(_areEqualDates(newDate,this._date)){
return;
}
this._date=newDate;
this.updateValue();
}

get time(){
return this._time;
}

set time(newTime){
if(_areEqualDates(newTime,this._time)){
return;
}
this._time=newTime;
this.updateValue();
}

get showDateError(){
return this.form[this._dateId].$touched&&!_.exists(this.date);
}

get showTimeError(){
return this.form[this._timeId].$touched&&!_.exists(this.time);
}};let


DateTimeDirective=class DateTimeDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['value','form'];
}

get templateUrl(){
return'/templates/directives/dateTimeDirective/dateTimeTemplate';
}

get controller(){
return DateTimeDirectiveController;
}};


module.exports=DateTimeDirective;
//# sourceMappingURL=dateTimeDirective.js.map
